import { memo, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { LargeFooter, SmallFooter } from '../../ui';
import useScrollPosition from '../../../utils/hooks/useScrollPosition';
import { setFooterApiCall } from '../../../app/base/commonSlice';

function Footer() {
  const dispatch = useDispatch();
  const elementRef = useRef(null);

  const scrollPosition = useScrollPosition();

  useEffect(() => {
    // @ts-ignore

    const intialPosition = elementRef?.current?.getBoundingClientRect().top;

    if (intialPosition < scrollPosition) {
      dispatch(setFooterApiCall(false));
    } else {
      dispatch(setFooterApiCall(true));
    }
  }, [dispatch, scrollPosition]);

  return (
    <div ref={elementRef} className="w-full">
      <LargeFooter />
      <SmallFooter />
    </div>
  );
}

export default memo(Footer);
